<template>
  <div class="marquee-wrap">
    <div class="marquee-track">
      <span
        v-for="(item, i) in loopedItems"
        :key="'mq-' + i"
        class="marquee-item"
        >{{ item }}<span class="marquee-dot"></span
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutMarquee",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    loopedItems() {
      return [...this.items, ...this.items];
    },
  },
};
</script>
